function Travel() {
    return ( <div>
        <h1>heyyyy !</h1>
    </div> );
}

export default Travel;